import { useRef, useState, useEffect } from 'react';

import { Button, } from 'react-bootstrap';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Portal from '@material-ui/core/Portal';
import MuiAlert from '@material-ui/lab/Alert';

import './styles.css';

import api from '../../services/api';

import NavBar from '../../components/NavBar/NavBar.js';
import ServerMonitoringTable from './ServerMonitoringTable';


const useStyles = makeStyles((theme) => ({
  alert: {
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    border: '1px solid',
  },
}));


function Monitoramento() {
  const [body, setBody] = useState([])
  const [avulsos, setAvulsos] = useState([])
  const [show, setShow] = useState(false)
  const container = useRef(null)
  const classes = useStyles()


  function Alert(props) {
    return <MuiAlert elevation={3} variant="filled" {...props} />
  }

  useEffect(() => {
    (async () => {
      api
        .get('/monitoramento')
        .then((response) => {
          const respost = response.data
          setBody(respost)
        })
        .catch((err) => {
          console.log(err)
          setBody([])
        })
    })();
  }, []);

  useEffect(() => {
    (async () => {
      api
        .get('/monitoramento/avulsos')
        .then((response) => {
          const respost = response.data
          setAvulsos(respost)
        })
        .catch((err) => {
          console.log(err)
          setAvulsos([])
        })
    })();
  }, []);

  const handleClick = () => {
    setShow(!show)
  }


  return (
    <NavBar >
      <Container
        maxWidth="xl"
        component={Paper}
        elevation={5}
      >
        <br />
        <div>
          <Button
            type="button"
            onClick={handleClick}
            variant="outline-secondary"
          >
            { show ? 'Mostrando empresas avulsas' : 'Mostrar empresas avulsas' }
          </Button>

          <div className={classes.alert}>
            <br />
            <Alert
              variant="filled"
              severity="info"
              style={{
                width: '50%',
                marginLeft: '25%',
              }}
            >
              Todas as empresas
            </Alert>

            <br />

            <ServerMonitoringTable data={body} />

            {
              show ?
              <Portal container={container.current}>
                <Alert
                  variant="filled"
                  severity="info"
                  style={{
                    width: '50%',
                    marginLeft: '25%',
                  }}
                >
                  Empresas avulsas
                </Alert>

                <br />

                <ServerMonitoringTable data={avulsos} />
              </Portal> :
              null
            }
          </div>

          <div className={classes.alert} ref={container} />
        </div>
      </Container>
      <br />
    </NavBar>
  );
}

export default Monitoramento;
